var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnackbarError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_302)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.46939C7.84056 4.46939 4.46939 7.84056 4.46939 12C4.46939 16.1595 7.84056 19.5306 12 19.5306C16.1595 19.5306 19.5306 16.1595 19.5306 12C19.5306 7.84056 16.1595 4.46939 12 4.46939ZM12 3C16.9709 3 21 7.02904 21 12C21 16.9709 16.9709 21 12 21C7.02904 21 3 16.9709 3 12C3 7.02904 7.02904 3 12 3Z",
    fill: "#FE5754"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.13266C12.4057 7.13266 12.7347 7.46159 12.7347 7.86735V12.4592C12.7347 12.8649 12.4057 13.1939 12 13.1939C11.5943 13.1939 11.2653 12.8649 11.2653 12.4592V7.86735C11.2653 7.46159 11.5943 7.13266 12 7.13266Z",
    fill: "#FE5754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9643 15.9031C12.9643 16.4356 12.5326 16.8673 12 16.8673C11.4674 16.8673 11.0357 16.4356 11.0357 15.9031C11.0357 15.3705 11.4674 14.9388 12 14.9388C12.5326 14.9388 12.9643 15.3705 12.9643 15.9031Z",
    fill: "#FE5754"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnackbarError);
export default __webpack_public_path__ + "static/media/snackbar-error.c9278f5f3cd51c9b6db44e22908deec7.svg";
export { ForwardRef as ReactComponent };